import styled from 'styled-components';

type OptionItemProps = {
  isActive: boolean;
  name: string;
  'data-testid'?: string;
};

export const OptionItem = styled.li<OptionItemProps>``;
